<template>
  <div class="bfafooter">
    <h4>
      Studio Novati - viale Varese, 11 - 22100 Como - <a href="mailto:info@studio-novati.it">info@studio-novati.it</a> - Tino Novati +39 335 6030294 - Luca Novati +39 338 7151003
    </h4>
  </div>
</template>

<script>
export default {
  name: 'BfaFooter',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bfafooter {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: rgba(0,0,0,0.5);
  }

  h4 {
    text-align: center;
    color: white;
    font-size: small;
    font-weight: 400;
  }

  a {
    color: white;
  }
</style>
